import { v4 as uuidv4 } from "uuid";
import { getBackgroundImageOptions } from "@/react/components/shared/BuilderUI/utils/backgroundHelpers";
import {
  getMarginOptions,
  getPaddingOptions,
} from "@/react/components/shared/BuilderUI/utils/boxModelStyleHelpers";
import { getBackgroundColorOptions } from "@/react/components/shared/BuilderUI/utils/buttonStyleHelpers";
import { getColorOptions } from "@/react/components/shared/BuilderUI/utils/textStyleHelpers";
import { defaultData as defaultPData } from "@/react/components/shared/Emails/VisualEmailBuilder/Blocks/Content/PBlock/P1BlockDefaultData";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import {
  createH1Block,
  createPBlock,
} from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";
import { createButtonBlock } from "@circle-react-shared/Emails/VisualEmailBuilder/Blocks/Content/createButtonBlock";
import { defaultData as defaultH1Data } from "@circle-react-shared/Emails/VisualEmailBuilder/Blocks/Headings/H1Block/H1BlockDefaultData";
import { getAlignmentOptions } from "../../../Utils/buttonStyleHelpers";
import { defaultStyles } from "./defaultStyles";

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "HeroBlock5",
  props: {
    headerContent: {
      prop: "children",
      type: "children",
      value: [
        createH1Block({
          text: "Heading",
          baseData: defaultH1Data,
          styles: {
            color: getColorOptions("var(--theme-email-color-1)"),
            margin: getMarginOptions({
              defaultValue: {
                marginTop: "12",
                marginBottom: "12",
                marginLeft: "24",
                marginRight: "24",
              },
            }),
          },
        }),
        createPBlock({
          text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique.",
          baseData: defaultPData,
          styles: {
            color: getColorOptions("var(--theme-email-color-1)"),
            margin: getMarginOptions({
              defaultValue: {
                marginTop: "12",
                marginBottom: "12",
                marginLeft: "24",
                marginRight: "24",
              },
            }),
          },
        }),
      ],
    },
    primaryButton: {
      prop: "children",
      type: "children",
      value: [
        createButtonBlock({
          text: "Button",
          href: "#",
          buttonType: "primaryButton",
          styles: {
            alignment: getAlignmentOptions("left"),
            margin: getMarginOptions({
              defaultValue: {
                marginTop: "12",
                marginBottom: "12",
                marginLeft: "24",
                marginRight: "24",
              },
            }),
          },
        }),
      ],
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        backgroundColor: getBackgroundColorOptions({
          defaultValue: defaultStyles.backgroundColor,
        }),
        backgroundImage: getBackgroundImageOptions(),
        padding: getPaddingOptions({
          defaultValue: defaultStyles.padding,
        }),
        margin: getMarginOptions({
          defaultValue: defaultStyles.margin,
        }),
      },
    },
  },
};
